







































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  Project,
  saveProjectCsv,
  getAllProjects,
  suspendProject,
  closeProject,
  SuspendProjectCommand,
  GetProjectsQuery,
  CloseProjectCommand,
  importCsvProjectChangeStatus
} from "@/api/project-api";
import { formatShort } from "@/helpers/date-helper";

import AppHeader from "./AppHeader.vue";

import UploadFileSpec from "@/models/specs/UploadFileSpec";
// import { ServiceArise, getUserAriseServices } from "../api/service-api";
import VProjectList, { IProjectListItem } from "@/components/VProjectList.vue";

import VToolbar from "@/components/V-Toolbar.vue";
import SearchProjectBar from "../components/SearchProjectBar.vue";
import { getProjectStatus, isProjectStatus } from "@/models/project-status";
import { isNewProject } from "@/preferences";
import { getStatusNewProject } from "@/api/project-api";
import { getStatusCode, getValueStatusInvoice } from "@/status";

@Component({
  components: {
    VToolbar,
    AppHeader,
    VProjectList,
    SearchProjectBar
  }
})
export default class ProjectListPage extends Vue {
  closedProjectVisible: boolean = false;
  isLoading: boolean = false;
  getInvoice = false;
  // TODO: まだ使ってない
  //   private roles: ServiceArise[] = [];

  message: string = "";
  private projects: Project[] = [];
  resetLoadInfinite = 0;

  get service() {
    return this.$store.state.service;
  }

  buttonsAction = [
    {
      text: "終了した現場を表示する",
      hide: false,
      disable: false,
      id: 1
    },
    {
      text: "終了した現場を非表示にする",
      hide: true,
      disable: false,
      id: 2
    },
    {
      text: "請求対象現場のみ表示する",
      hide: false,
      disable: false,
      id: 3
    },
    {
      text: "請求対象現場のみ表示を解除する",
      hide: true,
      disable: false,
      id: 4
    }
  ];

  get labelButton() {
    return this.buttonsAction
      .filter(item => !item.hide)
      .map(item => ({
        text: item.text,
        hide: item.hide,
        disable: item.disable,
        id: item.id,
        click: (id: number) => this.handleClick(id)
      }));
  }

  handleClick(id: number) {
    switch (id) {
      case 1:
        this.updateToggleDisable([3, 4], true);
        this.updateToggleHide(1, 0);
        this.closedProjectVisible = true;

        break;
      case 2:
        this.updateToggleDisable([3, 4], false);
        this.updateToggleHide(0, 1);
        this.closedProjectVisible = false;

        break;
      case 3:
        this.updateToggleDisable([1, 2], true);
        this.updateToggleHide(3, 2);
        this.getInvoice = true;

        break;

      case 4:
        this.updateToggleDisable([1, 2], false);
        this.updateToggleHide(2, 3);
        this.getInvoice = false;

        break;
    }
  }

  updateToggleDisable(ids: number[], disable: boolean = true) {
    this.buttonsAction.forEach(button => {
      if (ids.includes(button.id)) {
        button.disable = disable;
      }
    });
  }

  updateToggleHide(indexShow: number, indexHide: number) {
    this.buttonsAction[indexShow].hide = false;
    this.buttonsAction[indexHide].hide = true;
  }

  get items(): IProjectListItem[] {
    return this.getVisibleProjects().map(ListItem);
  }

  /**
   * 表示する現場を取得する
   */
  private getVisibleProjects() {
    if (this.getInvoice) {
      return this.projects.filter(p => {
        return getValueStatusInvoice().includes(p.statusProject);
      });
    }

    if (!this.closedProjectVisible) {
      return this.projects.filter(p => {
        if (isNewProject(p.created)) {
          return p.statusProject < getStatusCode("施工終了", true);
        } else {
          return p.status !== "施工終了";
        }
      });
    }

    return this.projects;
  }

  // TODO: まだ使ってない
  //   public created() {
  //     this.initServiceRoles();
  //   }

  @Watch("$route", { immediate: true })
  onRouteChanged() {
    this.projects = [];
    this.resetLoadInfinite += 1;
  }
  query(currentLength?: number): GetProjectsQuery {
    const status = String(this.$route.query.status || "");
    return {
      keyword: String(this.$route.query.keyword || ""),
      client: String(this.$route.query.client || ""),
      status: isProjectStatus(status) ? status : undefined,
      projectCount: currentLength
    };
  }

  async uploadCsv(files: FileList) {
    if (!files.length) return;
    const spec = new UploadFileSpec();
    if (!spec.isSatisfied(files[0])) {
      alert(spec.errors);
      return;
    }
    this.isLoading = true;
    const data = new FormData();
    data.append("csv", files[0]);
    try {
      await saveProjectCsv(data);
      alert("アップロードが完了しました。");
    } catch (e) {
      if (e.length) {
        alert((e as string[]).join("\n"));
      } else {
        alert(
          "アップロードできませんでした。\nページを再読み込みしてください。"
        );
      }
      return;
    } finally {
      this.isLoading = false;
    }
    this.projects = [];
    this.resetLoadInfinite += 1;
  }

  async handleImportCsvChangeStatusSuccess(files: FileList) {
    if (!files.length) return;

    const spec = new UploadFileSpec();
    if (!spec.isSatisfied(files[0])) {
      alert(spec.errors);
      return;
    }

    this.isLoading = true;
    const data = new FormData();
    data.append("csv", files[0]);

    try {
      await importCsvProjectChangeStatus(data);
      alert("アップロードが完了しました。");
    } catch (e) {
      alert((e as string[]).join("\n"));
      return;
    } finally {
      this.isLoading = false;
    }
    this.projects = [];
    this.resetLoadInfinite += 1;
  }

  /**
   * 現場を検索する
   * @param query
   */
  search(query: Record<string, string>) {
    this.$router.push({ query });
    this.message = "";
  }

  async toggle() {
    this.closedProjectVisible = !this.closedProjectVisible;
  }

  async loadInfinite($state: any) {
    const loadedProjectItems: Project[] = await getAllProjects(
      this.query(this.projects.length)
    );

    if (loadedProjectItems.length) {
      if (loadedProjectItems.length == 0) {
        this.projects = loadedProjectItems;
      } else {
        this.projects = this.projects.concat(loadedProjectItems);
      }
      $state.loaded();
    } else {
      $state.complete();
    }

    if (!this.projects.length) {
      this.message = "検索結果はありません";
    }
  }

  // TODO: まだ使ってない
  //   private async initServiceRoles() {
  //     this.roles = await getUserAriseServices();
  //   }

  async suspend(command: SuspendProjectCommand) {
    let res = await suspendProject(command);
    let targetPrj = this.projects.filter(p => command.id == p.projectId)[0];
    targetPrj.status = getProjectStatus(res.status);

    if (isNewProject(targetPrj.created)) {
      const data = await getStatusNewProject(targetPrj.projectId);
      targetPrj.statusProject = +data.statusProject;
      targetPrj.colorName = data.colorName;
    }
  }

  async close(command: CloseProjectCommand) {
    let res = await closeProject(command);
    let targetPrj = this.projects.filter(p => command.id == p.projectId)[0];
    targetPrj.status = getProjectStatus(res.status);
    targetPrj.closed = command.closed;

    if (isNewProject(targetPrj.created)) {
      const data = await getStatusNewProject(targetPrj.projectId);
      targetPrj.statusProject = +data.statusProject;
      targetPrj.colorName = data.colorName;
      targetPrj.end = command.endDate ? command.endDate : "";
    }

    this.$store.dispatch("updateProjects");
  }
}

/**
 * 一覧の項目に変換する
 */
function ListItem(project: Project): IProjectListItem {
  return {
    project: {
      id: String(project.projectId),
      name: project.name,
      icon: project.icon
    },
    place: project.address,
    client: {
      company: project.client ? project.client.company.name : "",
      staff: project.clientStaff ? project.clientStaff.name : ""
    },
    createdAt: formatShort(project.created),
    status: project.status,
    _rowVariant: isNewProject(project.created)
      ? getValueStatusInvoice(true).includes(project.statusProject)
        ? "secondary"
        : ""
      : project.closed
      ? "secondary"
      : "",
    statusProject: project.statusProject,
    colorName: project.colorName ? project.colorName : "",
    start: project.start,
    end: project.end,
    closed: project.closed
  };
}
